import { Button, PageWrapper, rem } from '@innovyze/stylovyze';
import { Grid } from '@mui/material';
import styled from 'styled-components';

export const PageWrapperStyled = styled(PageWrapper)`
	position: relative;
	width: 100%;
	height: 100%;
	max-width: none;
`;

export const BodyGridStyled = styled(Grid)`
	padding-top: ${rem(24)};
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
	column-gap: ${rem(24)};
	row-gap: ${rem(24)};
`;

export const CapitalizedButton = styled(Button)`
	text-transform: capitalize;
`;

export const StyledButton = styled(CapitalizedButton)`
	&& {
		color: #ffffff;
		background-color: #007ca0;
		margin-top: ${rem(25)};
		margin-bottom: ${rem(20)};
		padding: 6px 12px;
	}
`;

export const ButtonGroupStyled = styled.div`
	display: inline-flex;
`;

export const CancelButtonStyled = styled(Button)`
	margin-right: ${rem(15)};
`;
